import signatureModel from './signature-model'
import { mailSignature } from '@/api/mail'

const columns = [
  {
    title: '',
    enTitle: 'Journal Abbr.',
    width: 120,
    dataIndex: 'name',
    slot: 'omission'
  },
  {
    title: '',
    enTitle: 'Mail Signature',
    width: 600,
    dataIndex: 'emailSignature',
    slot: 'emailSignature'
  },
  {
    title: '',
    enTitle: 'Modified',
    width: 120,
    dataIndex: 'signatureUpdateTime',
    slot: 'date'
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 80,
    dataIndex: 'actions',
    slot: 'actions'
  }
]
export default {
  components: {
    signatureModel
  },
  data() {
    return {
      params: {},
      columns: columns,
      dataSource: [],
      letterFamilyList: [],
      selectList: [],
      isVisable: false,
      info: null
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    async getList() {
      this.dataSource = await mailSignature.getAll()
      // mailSignature.getAll().then(res => {
      //   this.dataSource = res
      // })
    },
    signature(record) {
      this.isVisable = true
      this.info = record
    },
    cancel() {
      this.isVisable = false
      // this.getList()
    }
  }
}
